var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 33 33;270 33 33",
    begin: "0s",
    dur: "1.4s",
    fill: "freeze",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    strokeWidth: 6,
    stroke: "#000",
    strokeLinecap: "round",
    cx: 33,
    cy: 33,
    r: 30,
    strokeDasharray: 187,
    strokeDashoffset: 610
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 33 33;135 33 33;450 33 33",
    begin: "0s",
    dur: "1.4s",
    fill: "freeze",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "187;46.75;187",
    begin: "0s",
    dur: "1.4s",
    fill: "freeze",
    repeatCount: "indefinite"
  })))));
}

export default SvgCircleLoading;